import React from "react";

import { Label } from "@packages/ds";

import { ENVIRONMENT_TYPES } from "Constants/constants";
import Select from "ds/Select";
import { capitalize } from "Libs/utils";

import * as S from "./BranchPane.styles";

import type { Environment } from "@packages/client";

type BranchInputsProps = {
  branchName: string;
  onBranchNameChange: (v) => void;
  onEnvironmentTypeChange: (v) => void;
  environment?: Environment;
  inputValues: {
    input: {
      label: string;
      placeholder: string;
    };
    dropdown: {
      label: string;
    };
  };
};

const BranchInputs = ({
  branchName,
  onBranchNameChange,
  onEnvironmentTypeChange,
  environment,
  inputValues
}: BranchInputsProps) => {
  return (
    <S.InputsWrapper>
      <S.Input
        required
        id="environment-branch-name-input"
        label={inputValues.input.label}
        placeholder={inputValues.input.placeholder}
        onChange={onBranchNameChange}
        value={branchName}
      />
      {environment?.type && (
        <div>
          <Label required>{capitalize(inputValues.dropdown.label)}</Label>
          <Select
            id="environment-type-options"
            options={ENVIRONMENT_TYPES.filter(e => e !== "production").map(
              et => ({
                value: et,
                label: capitalize(et)
              })
            )}
            onChange={onEnvironmentTypeChange}
            defaultValue={{
              value: "development",
              label: "Development"
            }}
          />
        </div>
      )}
    </S.InputsWrapper>
  );
};

export default BranchInputs;
